import { render } from "./bandBank.vue?vue&type=template&id=5af75f54&scoped=true"
import script from "./bandBank.vue?vue&type=script&lang=js"
export * from "./bandBank.vue?vue&type=script&lang=js"

import "./bandBank.vue?vue&type=style&index=0&id=5af75f54&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af75f54"]])

export default __exports__